import { createFileRoute } from '@tanstack/react-router';
import Journeys from '@/pages/journeys';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$')({
  component: Journeys,
});
